import { Button } from 'react-bootstrap'
import ButtonWithTooltip from '../ButtonWithTooltip'

interface TrBtnProps {
  children: React.ReactNode,
  action?: () => void,
  text?: string
}

const TrBtn = ({ children, action, text = "" }: TrBtnProps) => (
  <ButtonWithTooltip text={text} delay={750}>
    <Button variant="" className="btn-sm bg-white rounded-2 shadow-btn border-light" onClick={action}>
      {children}
    </Button>
  </ButtonWithTooltip>
)

export default TrBtn